export const steps = ["Products and Discounts", "Terms & Conditions", "Add-ons (optional)", "Summary"];
